<template>
	<div class="login-page">
		<el-header class="d-flex align-items-center" style="padding:0px; background-color: #fff;box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);position: relative; z-index: 999;">
			<!-- 左侧内容（如果有） -->
			<div class="mr-auto">
				<!-- {{ $t('message.switchSuccess') }} -->
			<!-- 左侧内容 -->
			
			<div class="ml-3" style="width: 100%;height: 60px;align-items:center;justify-content: center;display: flex;">
				
				<img style="height: 70%;object-fit:contain;"  src="../../assets/img/black.png" alt="">
			</div>
				
			</div> 

			<!-- 右侧的 el-dropdown -->
			<div  ref="menuicon" style="
			color: #545c64; font-size: 22px; cursor: pointer; padding: 20px;">
				<el-dropdown trigger="click" @command="changeLanguage">
					<span class="el-dropdown-link">
						{{ currentLangLabel }} <i  class="iconfont icon-yuyan ml-1"></i>
					</span>
					<el-dropdown-menu slot="dropdown">
					<el-dropdown-item command="cn">中文</el-dropdown-item>
					<el-dropdown-item command="en">English</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
		</el-header>
		
		
		<div style="width: 100%;height: 90vh;display: flex;align-items: center;">
			
			<el-row class="w-100">
			  <el-col :xs="1" :sm="6" :md="4" :lg="3" :xl="3">
				  <div class="pt-1"></div>
			  </el-col>
			  <el-col  :xs="22" :sm="10" :md="10" :lg="7" :xl="5">
				  <div class="card">
				  	<div class="login_nav">
				  		<el-tabs  v-model="activeName" :stretch="true" >
				  		    <el-tab-pane  :label="$t('reg.login')" name="login">
				  				<div class="card-body">
				  					<el-form ref="ruleform" :model="form" :rules="rules">
				  						<el-form-item prop="username">
				  							<el-input v-model="form.username" size="medium" :placeholder="$t('login.username')">
				  								<i slot="prefix" class="el-input__icon el-icon-user"></i>
				  							</el-input>
				  						</el-form-item>
				  						<el-form-item prop="password">
				  							<el-input v-model="form.password" type="password" size="medium" :placeholder="$t('login.password')">
				  								<i slot="prefix" class="el-input__icon el-icon-key"></i>
				  							</el-input>
				  						</el-form-item>
				  				
				  						<el-form-item prop="code">
				  							<el-input v-model="form.code" style="width: 50%;" type="text" size="medium" :placeholder="$t('login.code')">
				  								<i slot="prefix" class="el-input__icon el-icon-refresh"></i>
				  							</el-input>
				  							<div style="width: 45%;float: right;margin-left: 5%; " @click="refreshCode()">
				  								<v-sidentify ref="childRef"  :identifyCode="identifyCode" :styleOptions="{ letterSpacing: '10px', rotateRange: 5 }"></v-sidentify>
				  							</div>
				  						</el-form-item>
				  				
				  						
				  						
				  						<el-form-item>
				  							<el-button @click="submit" :loading="loading" type="primary" size="medium" class="w-100">
				  								{{loading?$t('message.login_time'):$t('message.login')}}
				  							</el-button>
				  						</el-form-item>
				  						
				  					</el-form>
				  				</div>
				  				
				  				
				  			</el-tab-pane>
				  		    <!-- <el-tab-pane :label="$t('reg.reg')" name="second">
				  				
				  				<div class="card-body">
				  					<el-form ref="ruleform_reg" :model="reg" :rules="rules_reg">
				  						<el-form-item prop="email">
				  							<el-input v-model="reg.email" size="medium" :placeholder="$t('reg.inpEmail')">
				  								<i slot="prefix" class="el-input__icon el-icon-message"></i>
				  							</el-input>
				  						</el-form-item>
				  						
				  						
				  						<el-form-item prop="phone">
				  							<el-input v-model="reg.phone" size="medium" :placeholder="$t('reg.inpPhone')">
				  								<i slot="prefix" class="el-input__icon el-icon-mobile-phone"></i>
				  							</el-input>
				  						</el-form-item>
				  						
				  						
				  						<el-form-item prop="company_name">
				  							<el-input v-model="reg.company_name" size="medium" :placeholder="$t('reg.inpName')">
				  								<i slot="prefix" class="el-input__icon el-icon-office-building"></i>
				  							</el-input>
				  						</el-form-item>
				  						
				  						<div class="mb-4 pt-3" style="font-size: 14px;text-align: center;color: #666;">{{$t('reg.tis')}} </div>
				  						<el-form-item>
				  							<el-button @click="submitReg" :disabled="loading" :loading="loading" type="primary" size=" medium" class="w-100">
				  								{{$t('reg.sub')}}
				  							</el-button>
				  						</el-form-item>
				  						
				  					</el-form>
				  				</div>
				  			</el-tab-pane> -->
							
							
							
				  		    
				  			
				  		  </el-tabs>
				  	</div>
				  	
				  	
				  	<!-- <div class="card-header bg-white">
				  		<h3 class="text-center mb-0 text-secondary">{{$t('system.title')}}</h3>
				  	</div> -->
				  	
				  	
				  	
				  	<!-- <div class="card-footer">
				  			
				  	</div> -->
				  </div>
			  </el-col>
			 
			</el-row>
		</div>
		
		
		
		
		
		
	</div>
</template>

<script>
	
	import {Decrypt,Encrypt} from '@/common/aes/utils.js'
	import Sidentify from '@/components/common/Sidentify.vue';
	import elementLocale from 'element-ui/lib/locale';
	import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
	import enLocale from 'element-ui/lib/locale/lang/en';

	import {
		mapGetters
	} from 'vuex';
	export default {
		components: {
			'v-sidentify': Sidentify
		},
		data() {
			return {
				activeName: 'login',
				language: localStorage.getItem('language') || 'cn', // 读取本地存储的语言
				langOptions: {
					'cn': '中文',
					'en': 'English'
				},

				identifyCodes: '123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ',
				identifyCode: '',
				img: '',
				loading: false,
				form: {
					username: "",
					password: "",
					googleCode: "",
					code: "",
					coo:"",
					data:""
				},
				reg:{
					email:'',
					phone:'',
					company_name:'',
				},
				rules: {
					username: [{
						required: true,
						message: this.$t('login.input_username'),
						trigger: "blur"
					}],
					password: [{
						required: true,
						message: this.$t('login.input_password'),
						trigger: "blur"
					}],
					code: [{
						required: true,
						message: this.$t('login.input_code'),
						trigger: "blur"
					}]
					
				},
				rules_reg: {
					email: [{
						required: true,
						message: this.$t('reg.inpEmail'),
						trigger: "blur"
					}],
					phone: [{
						required: true,
						message: this.$t('reg.inpPhone'),
						trigger: "blur"
					}],
					company_name: [{
						required: true,
						message: this.$t('reg.inpName'),
						trigger: "blur"
					}],
				}
			}
		},
		computed: {
			currentLangLabel() {
				return this.langOptions[this.language]; // 获取当前语言的名称
			},
			...mapGetters([
				'adminIndex'
			])

		},
		mounted() {
			this.identifyCode = ''
			this.makeCode(this.identifyCodes, 4)
			
			// 添加全局的键盘事件监听器
			window.addEventListener('keydown', this.handleKeydown);
		},
		beforeDestroy() {
		    // 移除全局的键盘事件监听器
		    window.removeEventListener('keydown', this.handleKeydown);
		  },
		created() {
			//this.getCaptcha()
		},
		methods: {
			changeLanguage(lang) {
				this.language = lang;
				this.$i18n.locale = lang;
				localStorage.setItem('language', lang);
				
				elementLocale.use(lang === 'cn' ? zhLocale : enLocale);
				this.$message.success(this.$t('message.switchSuccess'));
				// 刷新页面（强制重新加载应用）
				window.location.reload(); // 最直接的方式
			},

			handleKeydown(event) {
			  if (event.key === 'Enter') {
				this.submit()
			  }
			},
			randomNum(min, max) {
				return Math.floor(Math.random() * (max - min) + min)
			},
			refreshCode() {
				this.identifyCode = ''
				
				this.makeCode(this.identifyCodes, 4)
			},
			makeCode(o, l) {
				for (let i = 0; i < l; i++) {
					this.identifyCode += this.identifyCodes[
						this.randomNum(0, this.identifyCodes.length)
					]
				}
				this.identifyCode = Encrypt(this.identifyCode)
				this.form.coo = this.identifyCode
				this.form.data = Encrypt(this.randomNum(100,999)+ Math.random())
			},
			// getCaptcha() {
			// 	this.img = this.img + Math.random(); //给图片地址配一个无用的随机數
			// },
			submitReg() {
				let b = this.$route
				//let timestamp = new Date().getTime();
				this.$refs.ruleform_reg.validate((e) => {
					if (!e) return;
					// 提交表單
					this.loading = true
					this.axios.post('/admin/user/reg',
						this.reg
					).then(res => {
					
						
						if (res.data.code == 1) {
							let info = res.data.data.list
							
							this.reg = {
								email:'',
								phone:'',
								company_name:''
							}
							
							// 成功提示
							this.$message.success(this.$t('reg.tis2'));
							
							this.loading = false
						} else {
							this.loading = false
						}

					}).catch(err => {
						this.loading = false
						//console.log(err.response);
					})
					//this.$router.push({name:'index'})
				})
			},
			submit() {
				let b = this.$route
				//let timestamp = new Date().getTime();
				this.$refs.ruleform.validate((e) => {
					if (!e) return;
					// 提交表單
			
					this.loading = true
					this.axios.post('/admin/user/login',
						this.form
					).then(res => {
						//console.log(res);
						// if(res.data.encryption.code!=1){
						// 	this.$message.error(res.data.encryption.msg);
						// }
						
						if (res.data.code == 1) {
							let info = res.data.data.list
							
							// 存储到本地
							this.$store.commit('login', info)
			
							// 存储权限规则
							if (info.role && info.role.rules) {
								window.sessionStorage.setItem('rules', JSON.stringify(info.role.rules))
							}
							
							
							// 生成後台菜單
							this.$store.commit('createNavBar', info.tree)
							
							// 成功提示
							this.$message(this.$t('message.login_in'));
							
							this.loading = false
							// 跳转到首頁
							this.$router.push({
								name: this.adminIndex
							})
							
						} else {
							this.refreshCode()
							this.loading = false
						}
			
					}).catch(err => {
						this.refreshCode()
						this.loading = false
						//console.log(err.response);
					})
					//this.$router.push({name:'index'})
				})
			}
			
		}
	}
</script>

<style scoped>

	.login-page {
		position: relative;
		min-height: 100vh;
		background-image: url('../../assets/img/bg.png');
		background-size: cover;
		background-position:center 0%;
		background-repeat: no-repeat;
		
	}
	
	/* .login_nav .el-tabs__nav{
		padding: 10px 0!important;
	} */
	
	/deep/ .el-tabs__item {
	 height: 60px  !important; /* 上下左右内边距 */
	 line-height: 60px;
	}
	
	/deep/ .el-button{
		background-color:#469af8;
		border-color:#469af8;
		height: 48px  !important; /* 上下左右内边距 */
	}
	/deep/ .el-tabs__item.is-active,/deep/ .el-tabs__item:hover{
		color:#469af8;
	}
	/deep/ .el-tabs__active-bar{
		background-color:#469af8;
	}
	/deep/ .el-input__inner:focus{
    border-color: #469af8;
  }
	
	
	
</style>